import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTableFreePriceDisplay = () => {
  const currencyCode = useDisplayedCurrencyCode();
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "featureTable.pricing_jsx",
      elements: {
        PriceDisplay
      },
      options: {
        currencyCode,
        seleniumId: 'free',
        price: 0
      }
    })
  });
};
export default FeatureTableFreePriceDisplay;